<template>
  <div id="app">
	    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  *{
  ::-webkit-scrollbar {
      /*隐藏滚轮*/
      display: none;
      }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue



// WEBPACK FOOTER //
// src/App.vue